/*
 * Copyright 2025, Airspan Networks, Inc.
 * All Rights Reserved.
 */
import React, { useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../../components/ui/tabs";
import Activity from "../../../components/Nodes/PerformanceDisplay/Activity/Activity";
import ThresholdCrossing from "../../../components/Nodes/PerformanceDisplay/ThresholdCrossing/ThresholdCrossing";

const ExternalPerformanceDisplay: React.FC = () => {
  const [activeTab, setActiveTab] = useState("activity");

  return (
    <div>
      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="inline-flex h-9 w-fit shrink-0 self-start items-stretch gap-0.5 rounded-full border border-border bg-transparent dark:bg-muted p-0.5 text-muted-foreground">
          <TabsTrigger
            value="activity"
            className="rounded-full !bg-transparent px-4 h-full inline-flex items-center justify-center text-sm font-medium text-muted-foreground !shadow-none transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 data-[state=active]:!bg-muted dark:data-[state=active]:!bg-card data-[state=active]:text-foreground data-[state=active]:!shadow-sm"
          >
            Activity
          </TabsTrigger>
          <TabsTrigger
            value="thresholdCrossing"
            className="rounded-full !bg-transparent px-4 h-full inline-flex items-center justify-center text-sm font-medium text-muted-foreground !shadow-none transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 data-[state=active]:!bg-muted dark:data-[state=active]:!bg-card data-[state=active]:text-foreground data-[state=active]:!shadow-sm"
          >
            Threshold Crossing
          </TabsTrigger>
        </TabsList>

        <TabsContent value="activity" className="mt-3">
          <Activity />
        </TabsContent>
        <TabsContent value="thresholdCrossing" className="mt-3">
          <ThresholdCrossing />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default ExternalPerformanceDisplay;